import React from 'react'
import {Checkbox} from '@sabre/spark-react'

const checkboxLayout = (locals) => {
    const options = {
        errorMessage: locals.hasError ? locals.error.props.children : null,
        onChange: value => locals.onChange(value),
        value: locals.value,
        disabled: locals.disabled,
        label: locals.label,
        required: !locals.typeInfo.isMaybe,
        checked: locals.value
    }

    return (
        <Checkbox {...options} className="col-md-6 spark-pad-l-2"/>
    )
}

export default checkboxLayout


// WEBPACK FOOTER //
// ./src/shared/components/tcomb/sparkCheckboxLayout.js